import { Button, Tooltip } from 'antd';
import React from 'react';
import classes from '../RelatedRooms.module.scss';
import { PlusOutlined } from '@ant-design/icons';
import { useAppDispatch } from 'store/hook';
import { useTranslation } from 'react-i18next';
import { setCurrentRelatedRoomTerms, setIsOpenAttachRoomModal } from 'store/slices/dataRoomSlice';
import { IDocument } from 'interfaces';

type AddNewConnectButtonProps = {
  targetTerm?: IDocument;
  disabled?: boolean;
};

const AddNewConnectButton = ({targetTerm, disabled}: AddNewConnectButtonProps) => {
  const { t } = useTranslation();  
  const dispatch = useAppDispatch();

  const openCreatingNewConnection = () => {
    targetTerm?.children && dispatch(setCurrentRelatedRoomTerms(targetTerm?.children));    
    dispatch(setIsOpenAttachRoomModal({isOpen: true, parentRoom: targetTerm?.related_room || null}));
  };  

  return ( disabled
    ? ( 
      <Tooltip title={t('Settings.relatedRooms.noPermissionToAdd', {room: targetTerm?.related_room?.name})}>
        <Button
          onClick={openCreatingNewConnection}
          className={classes.btnAdd}
          color='default'
          size='large'
          variant='dashed'
          icon={<PlusOutlined />}
          disabled={disabled}
        >
          {t('Settings.relatedRooms.addConnection')}
        </Button>
      </Tooltip>
    ) : (
      <Button
        onClick={openCreatingNewConnection}
        className={classes.btnAdd}
        color='default'
        size='large'
        variant='dashed'
        icon={<PlusOutlined />}
      >
        {t('Settings.relatedRooms.addConnection')}
      </Button>
    )
    
  )
}

export default AddNewConnectButton;
